// api.js // Small API layer; add credentials:true if you use cookies
const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7000';

export async function fetchWebsiteByHost(hostname) {
  // Backend should support this (e.g., /api/websites/by-domain?host=club.se)
  const res = await fetch(`${API_BASE}/api/websites/by-domain?host=${encodeURIComponent(hostname)}`, {
    credentials: 'include'
  });
  if (!res.ok) throw new Error('Failed to resolve website by host');
  return res.json();
}

export async function fetchWebsiteById(id) {
  const res = await fetch(`${API_BASE}/api/websites/${id}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to load website');
  return res.json();
}

// New: fetch normalized site contents (articles + pages) for a website
export async function fetchSiteContents(websiteId) {
  const url = `${API_BASE}/api/site-contents?websiteId=${websiteId}`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to load site contents');
  return res.json(); // expect [{ type: 'article'|'page', title, slug, content, ... }, ...]
}

//  hämta presigned download-url för privata filer (PDF, bilder, etc.)
export async function getDownloadUrlForPrivate(key) {
  const res = await fetch(`${API_BASE}/api/media/download-url`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ key }),
  });

  if (!res.ok) {
    throw new Error('Failed to get download URL');
  }

  const data = await res.json();
  return data.url;
}
